import { Box, type BoxProps } from '@lemonade-hq/cdk';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import type React from 'react';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export type SectionPage = 'renters' | 'homeowners' | 'home' | 'car' | 'life' | 'bundles' | 'pet' | 'fsd';

interface SectionEventWrapperProps extends BoxProps, React.ComponentProps<'div'> {
  children: React.ReactNode;
  name: string;
  page: SectionPage;
  width?: string;
  position?: number;
}

export const SectionEventWrapper: React.FC<SectionEventWrapperProps> = ({
  name: section_name,
  page,
  children,
  position,
  ...props
}) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const { trackEvent } = useAnalyticsContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies:  justification: inView is the only dependency
  useEffect(() => {
    if (inView) {
      trackEvent('page.section.viewed', {
        section_name,
        page,
        ...(position ? { section_position: position } : {}),
      });
    }
  }, [inView]);

  return (
    <Box ref={ref} {...props}>
      {children}
    </Box>
  );
};
